import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pm-plantype',
  templateUrl: './plantype.component.html',
  styleUrls: ['./plantype.component.css']
})
export class PlantypeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
